import { AppState } from "../../../redux-configuration/AppState";

export const uploadAdvancedImageLoadingSelector = (appState: AppState): boolean => appState.company.uploadImage.loading
export const uploadAdvancedImageErrorSelector = (appState: AppState): string | undefined => appState.company.uploadImage.error
export const uploadedAdvancedImageSelector = (appState: AppState): string | undefined => appState.company.uploadImage.imageUrl
